<template>
  <div>
    <el-card>
      <div style="display: flex">
        <div style="width: 50%">
          <el-row>
            <el-col v-if="isShow">
              <el-button :disabled="editFlag" size="small" type="warning" @click="stprEdit">编辑</el-button>
            </el-col>
            <el-col v-else>
              <el-button size="small" type="primary" @click="submit()">保存</el-button>
              <el-button size="small" @click="closeEdit">取消</el-button>
            </el-col>
          </el-row>
          <el-form ref="typesettingRef" :disabled="isShow" :model="prop" :rules="typesettingRules" label-width="120px" size="small">
            <el-row>
              <el-col :md="12">
                <el-form-item label="排版片数：" prop="typesetting_phr">
                  <el-input :value="prop.typesetting_phr" maxlength="9" show-word-limit @input="typesetting_phrChange">
                    <template slot="append">片</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="填卡人：" prop="user_id">
                  <el-select v-model="prop.user_id" filterable placeholder="请选择">
                    <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form :disabled="isShow" label="right" label-width="100px">
            <el-row>
              <el-form-item label="工序制作人：" size="small">
                <el-select
                  v-model="prop.user_producer_id"
                  :disabled="!['徐礼明', '盖新', 'Admin'].includes($cookies.get('userInfo').stff_name)"
                  filterable
                  placeholder="请选择"
                >
                  <el-option v-for="item in processList.map(x => x.o)" :key="item.user_id" :label="item.stff_name" :value="item.user_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="岗位：" size="small">
                <el-input :value="prop.stff_position" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="难度系数：" size="small">
                <el-input :value="prop.price" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item>
                <SubTable2 ref="subTable" :isShow="isShow" :stffList="processList" />
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { post } from '@api/request';
import helper from '@assets/js/helper';
import { spocAPI } from '@api/modules/spoc';
import SubTable2 from '@/views/DevelopManagement/SmplManage/TabChild/Componet/TabPanel/subTable/subTable2';

export default {
  components: {
    SubTable2
  },
  data() {
    return {
      isShow: true,
      typesettingRules: {
        typesetting_phr: [
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' },
          { required: true, message: '请填写排版用量', trigger: true }
        ]
      }
    };
  },
  watch: {
    'prop.rfid_typesetting_item'(newValue, oldValue) {
      this.$refs.subTable.tableData = newValue;
    }
  },
  props: {
    prop: Object,
    rfid_perm_status: Number,
    rfid_Info: Object,
    editFlag: Boolean,
    mainIsShow: Boolean,
    originalTypesetting: Object,
    stffList: Array,
    processList: Array
  },
  methods: {
    stprEdit() {
      this.$emit('num');
      this.isShow = false;
    },
    submit() {
      this.$refs['typesettingRef'].validate(valid => {
        if (valid) {
          this.$confirm('此操作将保存修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(res => {
              let editBody = {};
              editBody = JSON.parse(JSON.stringify(this.prop));
              editBody.rfid_typesetting_id = this.prop.rfid_typesetting_id;
              editBody.rfid_typesetting_item = this.$refs.subTable.tableData.filter(x =>
                x.rfid_typesetting_id ? true : !x.rfid_typesetting_id && !x.destroy_flag
              );
              if (!editBody.rfid_id) {
                editBody.rfid_id = this.rfid_Info.rfid_id;
                editBody.user_id = this.rfid_Info.user_id;
                if (!editBody.user_producer_id) {
                  editBody.user_producer_id = this.rfid_Info.stff_id;
                  editBody.user_producer_name = this.rfid_Info.stff_name;
                }
              }
              post(spocAPI.edit_typesetting, editBody)
                .then(res => {
                  if (res.data.code === 0) {
                    this.$message.success(res.data.msg);
                    this.$emit('copyTypesetting', this.prop);
                  } else {
                    this.$message.error(res.data.msg);
                  }

                  this.$emit('del');
                })
                .catch(res => {
                  this.$message.error(res.data.msg);
                });

              this.isShow = true;
            })
            .catch(res => {});
        }
      });
    },
    closeEdit() {
      this.$confirm('此操作将取消修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          this.isShow = true;
          this.$message.info('已取消修改');
          this.$emit('del');
          this.prop.typesetting_phr = this.originalTypesetting.typesetting_phr;
        })
        .catch(res => {});
    },
    typesetting_phrChange(val) {
      val = this.keepNum99(val);
      this.$emit('typesetting_phrChange', val);
    },
    keepNum99(val) {
      let keepTNum = Number(helper.keepTNum(val));
      if (keepTNum > 99) {
        this.$message.warning('输入范围0～99超出最大限度');
        return 99;
      } else {
        return keepTNum;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>
